export const OPTIONS = [
    {
        label: "Joystick Left",
        value: "joy-left"
    },
    {
        label: "Joystick Right",
        value: "joy-right"
    },
    {
        label: "Joystick Up",
        value: "joy-up"
    },
    {
        label: "Joystick Down",
        value: "joy-down"
    },
    {
        label: "Fire 1",
        value: "fire1"
    },
    {
        label: "Fire 2",
        value: "fire2"
    },
    {
        label: "F1",
        value: "f1"
    },
    {
        label: "F2",
        value: "f2"
    },
    {
        label: "F3",
        value: "f3"
    },
    {
        label: "F4",
        value: "f4"
    },
    {
        label: "F5",
        value: "f5"
    },
    {
        label: "F6",
        value: "f6"
    },
    {
        label: "F7",
        value: "f7"
    },
    {
        label: "F8",
        value: "f8"
    },
    {
        label: "Run/Stop",
        value: "runstop"
    },
    {
        label: "Home",
        value: "home"
    },
    {
        label: "Delete",
        value: "delete"
    },
    {
        label: "Control",
        value: "control"
    },
    {
        label: "Restore",
        value: "restore"
    },
    {
        label: "Commodore Key",
        value: "commodore"
    },
    {
        label: "Left Shift",
        value: "leftshift"
    },
    {
        label: "Right Shift",
        value: "rightshift"
    },
    {
        label: "Return",
        value: "return"
    },
    {
        label: "Cursor Up",
        value: "cursorup"
    },
    {
        label: "Cursor Down",
        value: "cursordown"
    },
    {
        label: "Cursor Left",
        value: "cursorleft"
    },
    {
        label: "Cursor Right",
        value: "cursorright"
    },
    {
        label: "Space Bar",
        value: "space"
    },
    {
        label: "A",
        value: "a"
    },
    {
        label: "B",
        value: "b"
    },
    {
        label: "C",
        value: "c"
    },
    {
        label: "D",
        value: "d"
    },
    {
        label: "E",
        value: "e"
    },
    {
        label: "F",
        value: "f"
    },
    {
        label: "G",
        value: "g"
    },
    {
        label: "H",
        value: "h"
    },
    {
        label: "I",
        value: "i"
    },
    {
        label: "J",
        value: "j"
    },
    {
        label: "K",
        value: "k"
    },
    {
        label: "L",
        value: "l"
    },
    {
        label: "M",
        value: "m"
    },
    {
        label: "N",
        value: "n"
    },
    {
        label: "O",
        value: "o"
    },
    {
        label: "P",
        value: "p"
    },
    {
        label: "Q",
        value: "q"
    },
    {
        label: "R",
        value: "r"
    },
    {
        label: "S",
        value: "s"
    },
    {
        label: "T",
        value: "t"
    },
    {
        label: "U",
        value: "u"
    },
    {
        label: "V",
        value: "v"
    },
    {
        label: "W",
        value: "w"
    },
    {
        label: "X",
        value: "x"
    },
    {
        label: "Y",
        value: "y"
    },
    {
        label: "Z",
        value: "z"
    },
    {
        label: "1",
        value: "1"
    },
    {
        label: "2",
        value: "2"
    },
    {
        label: "3",
        value: "3"
    },
    {
        label: "4",
        value: "4"
    },
    {
        label: "5",
        value: "5"
    },
    {
        label: "6",
        value: "6"
    },
    {
        label: "7",
        value: "7"
    },
    {
        label: "8",
        value: "8"
    },
    {
        label: "9",
        value: "9"
    },
    {
        label: "0",
        value: "0"
    },
    {
        label: "+",
        value: "plus"
    },
    {
        label: "-",
        value: "minus"
    },
    {
        label: "£",
        value: "pound"
    },
    {
        label: "←",
        value: "leftarrow"
    },
    {
        label: "↑",
        value: "uparrow"
    },
    {
        label: "@",
        value: "at"
    },
    {
        label: "*",
        value: "asterick"
    },
    {
        label: ":",
        value: "colon"
    },
    {
        label: ";",
        value: "semicolon"
    },
    {
        label: "=",
        value: "equal"
    },
    {
        label: ",",
        value: "comma"
    },
    {
        label: ".",
        value: "period"
    },
    {
        label: "/",
        value: "slash"
    },
];


